enum FinancingTypeEnum {
    INSTALLMENT = "INSTALLMENT",
    CONSUMER_LOAN = "CONSUMER_LOAN",
    GOODS_FINANCING = "GOODS_FINANCING",
    OPERATING_LEASE = "OPERATING_LEASE",
}

export default FinancingTypeEnum;
